import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        msg:'',
        token:'',
        path:'',
        unitIdValue:'',
        stationIdValue:'',
        identityInfoValue:'',
    },

    mutations: {
        set_token(state, token) {
            state.token = token
            localStorage.token = token
        },
        del_token(state) {
            state.token = ''
            localStorage.removeItem('token')
        },
        set_path( state, path){
            state.path = path
        },
        change_unitIdValue(state,unitIdValue){
            state.unitIdValue = unitIdValue;
        },
        change_stationIdValue(state,stationIdValue){
            state.stationIdValue = stationIdValue;
        },
        change_identityInfoValue(state,identityInfoValue){
            state.identityInfoValue = identityInfoValue;
        }
    },

    getters: {},
    actions: {},
});




// WEBPACK FOOTER //
// ./src/store/index.js